export default __webpack_public_path__ + "static/media/danta_white_male.38f80640.png";